// Import SASS
import '../sass/style.scss'

// Import scripts
import  objectFitImages from 'object-fit-images';
import './modules/skip-link-focus-fix';
import './modules/sliders';
/* import './modules/instagram'; */
import './modules/search';
import Macy from 'macy';
import baguetteBox from 'baguettebox.js';
import inView from 'in-view';
import Sticky from 'sticky-js';
import Tabby from 'tabbyjs';
import './modules/map';
import './modules/dealers-filter';
import modals from './modules/modals.js';

// Hamburger menu
document.querySelector("#nav-toggle").addEventListener("click", function () {
	this.classList.toggle("active");
	let mainNav = document.querySelector('.main-navigation');
	mainNav.classList.toggle('toggled');
});


let tabsEls = document.querySelectorAll('[data-tabs]');
console.log(tabsEls);
if (tabsEls.length > 0) {
	var tabs = new Tabby('[data-tabs]');
};

// Masonry & Lightbox grid
const grid = document.querySelector('.grid');
if(grid) {
	const macy = Macy({
		container: '.grid',
		margin: 0,
		columns: 5,
		// waitForImages: true,
		breakAt: {
			940: 3,
			400: 2
		}
	});

	macy.runOnImageLoad(function () {
		macy.recalculate(true);
	}, true);

	baguetteBox.run('.grid', {
		animation: 'slideIn'
	});
}

inView('#first').on('enter', function() {
	document.querySelector('#first').classList.add('active');
});
inView('#second').on('enter', function () {
	document.querySelector('#second').classList.add('active');
});
inView('#third').on('enter', function () {
	document.querySelector('#third').classList.add('active');
});
inView.offset(600);



// Sticky JS
new Sticky('.contact');

// Detect mobile device
function detectMobile() {
	var check = false;
	(function (a) { 
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; 
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
}

// disable phone click on tablet + desktop
if (detectMobile() == false) {
	const phoneBtn = document.querySelector('.js-phone');
	if(phoneBtn) {
		phoneBtn.addEventListener('click', function(e) {
			e.preventDefault();
		});
	}
}

// Product fix
const prices = document.querySelectorAll('.price');
for(let i = 0; i < prices.length; i++) {
	const startPrice = prices[i].querySelector('.woocommerce-Price-amount:first-child').innerHTML;
	if (prices[i].children.length > 1) {
		prices[i].innerHTML = `Vanaf ${startPrice}`;
	}
}

// Translate 'No selection' --> 'Geen selectie'
const selectionStr = document.querySelectorAll('dl.component p');
for (let i = 0; i < selectionStr.length; i++) {
	const string = selectionStr[i].innerHTML;
	if (string === 'No selection') {
		let newString = string.replace("No selection", "Geen selectie");
		selectionStr[i].innerHTML = newString;
	}
}

objectFitImages();

modals.init( {
  backspaceClose: false
} );

function cookieModal() {
    const modul = document.querySelector('.modal__campagne');
    const link = document.querySelector('.modal__campagne__close');

    // Controleer of localStorage ouder is dan een dag
    const cookieTimestamp = localStorage.getItem('popupPrinsTimestamp');
    if (cookieTimestamp) {
        const now = new Date().getTime();
        const oneDay = 24 * 60 * 60 * 1000; // 1 dag in milliseconden
        if (now - parseInt(cookieTimestamp) > oneDay) {
            localStorage.removeItem('popupPrins');
            localStorage.removeItem('popupPrinsTimestamp');
        }
    }

    if (localStorage.getItem('popupPrins') !== 'accepted') {
        if (link) {
            link.addEventListener('click', () => {
                modul.style.display = 'none';
                localStorage.setItem('popupPrins', 'accepted');
                localStorage.setItem('popupPrinsTimestamp', new Date().getTime());
            });
        }
    }
}

if (document.querySelector('.modal__campagne') && localStorage.getItem('popupPrins') !== 'accepted') {
    const modal = document.querySelector('.modal__campagne');
    const modalbut = document.querySelector('.modal__button');

    window.addEventListener('load', function () {
            setTimeout(function () {
                modal.classList.add('fadeInUp');
                modal.classList.add('animated');
                modal.classList.add('active');

                modals.openModal(null, '#modal__campagne');
            }, 1000);
    });
}


if (document.querySelector(".modal__campagne")) {
  cookieModal();
}
